import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1209f7e0&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1209f7e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2022/sdGG/sdGGAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1209f7e0')) {
      api.createRecord('1209f7e0', component.options)
    } else {
      api.reload('1209f7e0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1209f7e0&scoped=true&", function () {
      api.rerender('1209f7e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/product/proManage/index.vue"
export default component.exports